var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltipText,
    offset: 16,
    delay: { show: 300, hide: 100 },
  }),expression:"{\n    content: tooltipText,\n    offset: 16,\n    delay: { show: 300, hide: 100 },\n  }"}],style:({
    position: 'absolute',
    top: _vm.position.top + 'px',
    left: _vm.position.left + 'px',
  })},[_c('button',{directives:[{name:"wave",rawName:"v-wave"}],staticClass:"create-comment-button",attrs:{"data-external":"create-comment-button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('BaseH4',{staticClass:"text hidden-xs-and-up"},[_vm._v(_vm._s(_vm.$t('cc_tooltip_add_comment')))]),_c('CreateCommentIcon',{staticClass:"create-comment-icon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }